var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('div',{staticClass:"fixed-info-icon",on:{"click":function($event){_vm.showModal('about-modal')}}},[_c('i',{staticClass:"fa fa-2x fa-info-circle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }